import { Grid } from '@simplywallst/ui-core';
import { Bones } from '@simplywallst/ui-core';
import { InnerContainer } from './styled';

const ArticleSkeleton = () => (
  <Grid alignContent="center" justifyItems="center">
    <InnerContainer>
      <Grid gap="20px 16px">
        <Bones maxWidth="40%" minHeight="30px" backgroundColor="black" />
        <Bones maxWidth="80%" minHeight="60px" backgroundColor="black" />
        <Bones maxWidth="60%" minHeight="32px" backgroundColor="black" />
      </Grid>
    </InnerContainer>
    <InnerContainer>
      <Grid gap="16px">
        <Bones maxWidth="40%" minHeight="16px" backgroundColor="black" />
        <Bones maxWidth="60%" minHeight="32px" backgroundColor="black" />
        <Bones maxWidth="40%" minHeight="32px" backgroundColor="black" />
        <Bones maxWidth="70%" minHeight="32px" backgroundColor="black" />
        <Bones maxWidth="50%" minHeight="32px" backgroundColor="black" />
        <Bones maxWidth="60%" minHeight="512px" backgroundColor="black" />
        <Bones maxWidth="40%" minHeight="32px" backgroundColor="black" />
      </Grid>
    </InnerContainer>
    <InnerContainer>
      <Grid gap="16px">
        <Bones maxWidth="40%" minHeight="16px" backgroundColor="black" />
        <Bones maxWidth="60%" minHeight="32px" backgroundColor="black" />
        <Bones maxWidth="40%" minHeight="32px" backgroundColor="black" />
        <Bones maxWidth="70%" minHeight="32px" backgroundColor="black" />
        <Bones maxWidth="50%" minHeight="32px" backgroundColor="black" />
        <Bones maxWidth="60%" minHeight="512px" backgroundColor="black" />
        <Bones maxWidth="40%" minHeight="16px" backgroundColor="black" />
        <Bones maxWidth="60%" minHeight="32px" backgroundColor="black" />
        <Bones maxWidth="40%" minHeight="32px" backgroundColor="black" />
        <Bones maxWidth="70%" minHeight="32px" backgroundColor="black" />
        <Bones maxWidth="50%" minHeight="32px" backgroundColor="black" />
      </Grid>
    </InnerContainer>
  </Grid>
);

export default ArticleSkeleton;
